import React from 'react';
import { CloudIcon, BrainIcon, CpuIcon, LayersIcon, GlobeIcon, DatabaseIcon, ServerIcon, MonitorIcon, BuildingIcon, ArrowRightIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <CloudIcon className="w-8 h-8" data-id="element-282" />,
    title: 'Hybrid Cloud Solutions',
    description: 'IBM Cloud partnership providing seamless integration between on-premise and public cloud environments.'
  }, {
    icon: <BrainIcon className="w-8 h-8" data-id="element-283" />,
    title: 'AI & ML Infrastructure',
    description: 'High-performance GPU compute clusters optimized for complex model training and inference.'
  }, {
    icon: <CpuIcon className="w-8 h-8" data-id="element-284" />,
    title: 'Cognitive Computing',
    description: 'Purpose-built environments for data-intensive workloads and advanced analytics processing.'
  }, {
    icon: <LayersIcon className="w-8 h-8" data-id="element-285" />,
    title: 'Multi-Cloud Management',
    description: 'Unified management and integration across AWS, Azure, Google Cloud, and private infrastructure.'
  }, {
    icon: <GlobeIcon className="w-8 h-8" data-id="element-286" />,
    title: 'Cloud-Native Hosting',
    description: 'Scalable, containerized application hosting with Kubernetes orchestration and microservices support.'
  }, {
    icon: <DatabaseIcon className="w-8 h-8" data-id="element-287" />,
    title: 'Data Storage & Backup',
    description: 'Enterprise-grade, encrypted storage solutions with automated backup and disaster recovery.'
  }, {
    icon: <ServerIcon className="w-8 h-8" data-id="element-288" />,
    title: 'Infrastructure as a Service',
    description: 'Scalable compute, storage, and networking resources available on-demand.'
  }, {
    icon: <MonitorIcon className="w-8 h-8" data-id="element-289" />,
    title: 'Managed Web Hosting',
    description: 'High-availability, scalable hosting solutions with 24/7 monitoring and dedicated support.'
  }, {
    icon: <BuildingIcon className="w-8 h-8" data-id="element-290" />,
    title: 'Colocation Services',
    description: 'Bring your own hardware to our secure, redundant Atlanta facility with premium connectivity.'
  }];
  return <section id="services" className="py-24 lg:py-32 bg-ucensys-navy relative" data-id="element-291">
      <div className="absolute inset-0 bg-dot-pattern opacity-30 pointer-events-none" data-id="element-292"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-293">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-294">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-295">
            Enterprise Cloud & Infrastructure Services
          </h2>
          <p className="text-lg font-body text-text-secondary" data-id="element-296">
            Comprehensive solutions designed to support your most demanding
            workloads, from legacy migrations to cutting-edge AI applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-297">
          {services.map((service, index) => <div key={index} className="group bg-ucensys-card border border-border-color rounded-xl p-8 hover:border-ucensys-teal/50 hover:shadow-teal-glow transition-all duration-300 flex flex-col h-full" data-id="element-298">
              <div className="w-14 h-14 rounded-lg bg-ucensys-navy border border-border-color flex items-center justify-center text-ucensys-teal mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-299">
                {service.icon}
              </div>
              <h3 className="text-xl font-heading font-semibold text-white mb-3" data-id="element-300">
                {service.title}
              </h3>
              <p className="text-text-secondary font-body text-sm leading-relaxed mb-8 flex-grow" data-id="element-301">
                {service.description}
              </p>
              <a href="#contact" className="inline-flex items-center gap-2 text-ucensys-teal font-body font-medium text-sm hover:text-ucensys-teal-light transition-colors mt-auto" data-id="element-302">
                Learn More{' '}
                <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-303" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}